<template>
    <div>
        <b-row class="mb-4">
            <b-col cols="12" md="3">
                <label>{{ $t('Type of Certificate') }} <span class="text-danger">*</span></label>
            </b-col>
            <b-col sm="12" md="9">
                <NewDocOption
                    :data="doc_type_list"
                    :ref="'doc_type'"
                    @selected-document="selectedDocumentBeneficiary($event)">
                </NewDocOption>
            </b-col>
        </b-row>

        <b-row class="mb-3">
            <b-col cols="12" md="3">
                <label>{{ $t('ID Photo') }} <span class="text-danger">*</span></label>
            </b-col>

            <b-col sm="12" md="3">
                <div class="d-flex justify-content-center">
                    <label class="pt-2">{{ $t('ID Photo Front Side') }} <span class="text-danger">*</span></label>
                    <span class="position-relative">
                        <button type="button" class="flat-button position-absolute" @click="togglePopup(1)">
                        <img :src="`${publicPath}/img/rcp/icon/btn-info.png`" class="align-top">
                        </button>
                        <NewPopupInfo :name="(params.beneficiaryIdType==1?'ic':'passport')+'_front'" v-if="showPopup_1" :addClass="'popup-info-center'"></NewPopupInfo>
                    </span>
                </div>

                <FileUploader  
                    :type="'browse'"
                    :ref="'id_photo_1'"
                    :default_image="params.beneficiaryIdFront"
                    :allowed_types = "['jpg','jpeg', 'png']"
                    :size="4*1024*1024"
                    @capture-file="captureFile($event,'beneficiaryIdFront')" 
                    @remove-image="removeImage($event,'beneficiaryIdFront')"
                    @toggle-camera="toggleCamera($event)">
                </FileUploader>
                <div v-if="error['beneficiaryIdFront']" class="invalid-feedback d-block mb-3">
                    {{$t(error['beneficiaryIdFront'])}}
                </div>
            </b-col>
        
            <b-col sm="12" md="3" v-if="params.beneficiaryIdType == 1">
                <div class="d-flex justify-content-center">
                    <label class="pt-2">{{ $t('ID Photo Back Side') }} <span class="text-danger">*</span></label>
                    <span class="position-relative">
                        <button type="button" class="flat-button position-absolute" @click="togglePopup(2)">
                        <img :src="`${publicPath}/img/rcp/icon/btn-info.png`" class="align-top">
                        </button>
                        <NewPopupInfo :name="(params.beneficiaryIdType==1?'ic':'passport')+'_national'" v-if="showPopup_2" :addClass="'popup-info-center'"></NewPopupInfo>
                    </span>
                </div>
                <FileUploader  
                    :type="'browse'"
                    :ref="'id_photo_2'"
                    :default_image="params.beneficiaryIdReverse"
                    :allowed_types = "['jpg','jpeg', 'png']"
                    :size="4*1024*1024"
                    @capture-file="captureFile($event,'beneficiaryIdReverse')" 
                    @remove-image="removeImage($event,'beneficiaryIdReverse')">
                </FileUploader>
                <div v-if="error['beneficiaryIdReverse']" class="invalid-feedback d-block mb-3">
                    {{$t(error['beneficiaryIdReverse'])}}
                </div>
            </b-col>
        </b-row>

        <b-row class="mb-3">
            <b-col cols="12" md="3">
                <label>{{ $t('ID Number') }} <span class="text-danger">*</span></label>
            </b-col>

            <b-col sm="12" md="9">
                <input type="text" class="form-control" v-model="params.beneficiaryIdNo" @keydown="onChange('beneficiaryIdNo')"/>
                <div v-if="error['beneficiaryIdNo']" class="invalid-feedback d-block mb-3">
                    {{$t(error['beneficiaryIdNo'])}}
                </div>
            </b-col>
        </b-row>

        <b-row class="mb-3">
            <b-col cols="12" md="3">
                <label>{{ $t('Beneficiary Name') }} <span class="text-danger">*</span></label>
            </b-col>

            <b-col sm="12" md="9">
                <input type="text" class="form-control" :placeholder="$t('Name')" v-model="params.beneficiaryName" @keydown="onChange('beneficiaryName')"/>
                <div v-if="error['beneficiaryName']" class="invalid-feedback d-block mb-3">
                    {{$t(error['beneficiaryName'])}}
                </div>
            </b-col>
        </b-row>

        <b-row class="mb-3">
            <b-col cols="12" md="3">
                <label>{{ $t('Date of Birth') }} <span class="text-danger">*</span></label>
            </b-col>

            <b-col sm="12" md="9">
                <date-picker v-model="params.beneficiaryBirthDate" :lang="lang_date" input-class="form-control" format="YYYY-MM-DD" value-type="YYYY-MM-DD" @change="onChange('beneficiaryBirthDate')"></date-picker>
                <div v-if="error['beneficiaryBirthDate']" class="invalid-feedback d-block mb-3">
                    {{$t(error['beneficiaryBirthDate'])}}
                </div>
            </b-col>
        </b-row>

        <b-row class="mb-3">
            <b-col cols="12" md="3">
                <label>{{ $t('Certificate Validity') }} <span class="text-danger">*</span></label>
            </b-col>

            <b-col sm="12" md="9">
                <date-picker v-model="params.beneficiaryCertExpiryDate" :lang="lang_date" input-class="form-control" format="YYYY-MM-DD" value-type="YYYY-MM-DD" @change="onChange('beneficiaryCertExpiryDate')"></date-picker>
                <div v-if="error['beneficiaryCertExpiryDate']" class="invalid-feedback d-block mb-3">
                    {{$t(error['beneficiaryCertExpiryDate'])}}
                </div>
            </b-col>
        </b-row>

        <b-row class="mb-3">
            <b-col xl="4" sm="12">
                <div class="form-group mb-0">
                    <label>{{ $t('Province') }} <span class="text-danger">*</span></label>
                    <Select2 v-model="params.beneficiaryProvince" :options="provinceOpt" @select="onSelectProvince($event)" :settings='{ escapeMarkup: doEscapeMarkup,placeholder:$t("Province")}' class="form-control"/>
                    <div v-if="error['beneficiaryProvince']" class="invalid-feedback d-block mb-3">
                        {{$t(error['beneficiaryProvince'])}}
                    </div>
                </div>
            </b-col>
            <b-col xl="4" sm="12">
                <div class="form-group mb-0">
                    <label>{{ $t('City') }} <span class="text-danger">*</span></label>
                    <Select2 v-model="params.beneficiaryCity" :options="cityOpt" @select="onSelectCity($event)" :settings='{ escapeMarkup: doEscapeMarkup,placeholder:$t("City")}' class="form-control"/>
                    <div v-if="error['beneficiaryCity']" class="invalid-feedback d-block mb-3">
                        {{$t(error['beneficiaryCity'])}}
                    </div>
                </div>
            </b-col>
            <b-col xl="4" sm="12">
                <div class="form-group mb-0">
                    <label>{{ $t('District') }}</label>
                    <Select2 v-model="params.beneficiaryArea" :options="districtOpt" @select="onSelectDistrict($event)" :settings='{ escapeMarkup: doEscapeMarkup,placeholder:$t("District")}' class="form-control"/>
                    <div v-if="error['beneficiaryArea']" class="invalid-feedback d-block mb-3">
                        {{$t(error['beneficiaryArea'])}}
                    </div>
                </div>
            </b-col>
        </b-row>

        <b-row class="mb-3">
            <b-col xl="12">
                <div class="form-group mb-0">
                    <label>{{ $t('permanent address (detailed address)') }} <span class="text-danger">*</span></label>
                    <input type="text" name="beneficiaryAddress" v-model="params.beneficiaryAddress" class="form-control" @keydown="addressCondition($event)" @keyup="onchangeAddress($event)"/>
                    <div v-if="error['beneficiaryAddress']" class="invalid-feedback d-block mb-3">
                        {{$t(error['beneficiaryAddress'])}}
                    </div>
                </div>
            </b-col>
        </b-row>

        <b-row class="mb-3">
            <b-col cols="12" md="3">
                <label>{{ $t('Holdings ratio (%)') }} <span class="text-danger">*</span></label>
            </b-col>

            <b-col sm="12" md="9">
                <input type="text" class="form-control" :placeholder="$t('Please enter shareholding ratio')" v-model="params.beneficiaryShareholderRatio" @keydown="onChange('beneficiaryShareholderRatio')"/>
                <div v-if="error['beneficiaryShareholderRatio']" class="invalid-feedback d-block mb-3">
                    {{$t(error['beneficiaryShareholderRatio'])}}
                </div>
            </b-col>
        </b-row>
    </div>

</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Select2 from 'v-select2-component';

import NewDocOption from "@/components/Kyc/NewDocOption";
import FileUploader from '@/components/Kyc/FileUploader.vue';
import NewPopupInfo from '@/components/NewPopupInfo.vue';
import CreateAccount from '@/services/CreateAccount';

import 'vue2-datepicker/locale/zh-cn';
import 'vue2-datepicker/locale/zh-tw';
import 'vue2-datepicker/locale/ja';
import 'vue2-datepicker/locale/en';

export default {
  data() {
    return {
        publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
        showPopup_1:false,
        showPopup_2:false,
        showPopup_3:false,
        cityOpt:[],
        districtOpt:[],
        formData:{},
        lang_date:'en',
        maxSize:4,
        success:null,
        optional:['beneficiaryArea'],
        file:{
            beneficiaryIdFront:null,
            beneficiaryIdReverse:null
        },
        params:{
            beneficiaryIdType:1,
            beneficiaryIdFront:'',
            beneficiaryIdReverse:'',
            beneficiaryIdNo:'',
            beneficiaryName:'',
            beneficiaryBirthDate:'',
            beneficiaryCertExpiryDate:'',
            beneficiaryProvince:'',
            beneficiaryCity:'',
            beneficiaryArea:'',
            beneficiaryAddress:'',
            beneficiaryShareholderRatio:''
        },
        error:{
            beneficiaryIdType:'',
            beneficiaryIdFront:'',
            beneficiaryIdReverse:'',
            beneficiaryIdNo:'',
            beneficiaryName:'',
            beneficiaryBirthDate:'',
            beneficiaryCertExpiryDate:'',
            beneficiaryProvince:'',
            beneficiaryCity:'',
            beneficiaryArea:'',
            beneficiaryAddress:'',
            beneficiaryShareholderRatio:''
        }
    }
  },
  components:{
    NewDocOption,
    FileUploader,
    Select2,
    NewPopupInfo,
    DatePicker
  },
  props:['doc_type_list','provinceOpt','index','is_new','userNo','accountId'],
  mounted(){
    if(this.is_new === false){
        this.getAccount();
    }
  },
  methods:{
    getAccount(){
        let self = this;
        CreateAccount.list({
            search:self.search,
            start:0,
            length:-1
        }).then((response)=>{
            if (response.status == 200) {
                self.formData = response.data.data[0]['information'];
                
                Object.keys(this.params).forEach(function(key) {
                    if(typeof self.file[key]!=="undefined" && self.formData[key][self.index]){
                        self.file[key]=self.formData[key][self.index];
                        self.getFile(key,self.formData[key][self.index]);
                    }
                    else{
                        self.params[key]=self.formData[key][self.index];
                    }
                });

                this.$refs['doc_type'].doc_type = this.params.beneficiaryIdType-1;
                
                let data_province = this.params.beneficiaryProvince.split("_");
                this.getCity(data_province[0]);

                let data_city = this.params.beneficiaryCity.split("_");
                this.getDistrict(data_city[0]);
            }
        });
    },
    addressCondition($event){
        if($event.keyCode == 13){
            $event.preventDefault();
        }
        this.onChange('beneficiaryAddress');
    },
    onchangeAddress($event){
        let msg = $event.target.value.replace("\n", " ");
        $event.target.value = msg;
    },
    onSelectDistrict({id,text}){
        var self = this;
        this.onChange('beneficiaryArea');
    },
    onSelectCity({id,text,code}){
        var self = this;
        this.onChange('beneficiaryCity');
        if(text){
            this.beneficiaryArea="";
        }
        this.getDistrict(code);
    },
    onSelectProvince({id,text,code}){
        var self = this;
        this.onChange('beneficiaryProvince');
        self.districtOpt = [];
        if(text){
            this.beneficiaryCity = "";
            this.beneficiaryArea = "";
        }
        this.getCity(code);
    },
    getDistrict(code){
        this.districtOpt = [];
        CreateAccount.getDistrict({"city_id":code}).then(response => {
            const data = response.data.data;
            data.forEach(item => {
                this.districtOpt.push({"id":item.value,"text":item.text,"code":item.code});
            });
        }).catch(err => {
            this.checkError(err);
        });
    },
    getCity(code){
        this.cityOpt = [];
        CreateAccount.getCity({"province_id":code}).then(response => {
            const data = response.data.data;
            data.forEach(item => {
                this.cityOpt.push({"id":item.value,"text":item.text,"code":item.code});
            });
        }).catch(err => {
            this.checkError(err);
        });
    },
    onChange(name){
        this.error[name]="";
    },
    getFile(index,file_id){
        let self = this;
        CreateAccount.getFile({fileId:file_id}).then(response => {
            let data_file = response.data.data[0];

            if(data_file.type == 2 || data_file.type == 5){
                self.params.beneficiaryIdFront = data_file.file;
            }
            else if(data_file.type == 3){
                self.params.beneficiaryIdReverse = data_file.file;
            }
        });
    },
    validate(){
        let success = true;
        let self = this;
        Object.keys(this.params).forEach(function(key) {
            if(self.params.beneficiaryIdType==2 && key == "beneficiaryIdReverse"){
                self.error[key]="";
            }
            else if(!self.params[key]){
                success = false;
            }
        });

        return success;
    },
    uploadFile(){
        let self = this;
        this.success = null;
        
        this.error.beneficiaryIdFront='';
        this.error.beneficiaryIdReverse='';

        let fileList = [];
        if(self.params.beneficiaryIdFront.indexOf("base64")!=-1){
            fileList.push({
                "type":(self.params.beneficiaryIdType==1)?2:5,
                "maxSize":self.maxSize*1024*1024,
                "file":self.params.beneficiaryIdFront
            });
        }
        

        if(self.params.beneficiaryIdType==1 && self.params.beneficiaryIdReverse.indexOf("base64")){
            fileList.push(
                {
                    "type":3,
                    "maxSize":self.maxSize*1024*1024,
                    "file":self.params.beneficiaryIdReverse
                }
            );
        }

        if(fileList.length>0){
            CreateAccount.uploadFile({
                "accountId":self.accountId,
                "userNo":""+self.userNo,
                "fileUpload":fileList
            }).then(response => {
                const data = response.data.data;
                let fileList = data["file"];
                for(let i=0;i<fileList.length;i++){
                    if(fileList[i].type==2 || fileList[i].type==5){
                        // self.params.beneficiaryIdFront = fileList[i].file;
                        self.file.beneficiaryIdFront = fileList[i].fileId;
                    }
                    else if(fileList[i].type==3){
                        // self.params.beneficiaryIdReverse = fileList[i].file;
                        self.file.beneficiaryIdReverse = fileList[i].fileId;
                    }
                }
                self.success = true;
                self.$emit('file-uploaded');
            }).catch(err => {
                self.checkError(err);
            });
        }
        else{
            self.success = true;
            self.$emit('file-uploaded');
        }
    },
    checkError(err){
        try{
            let self = this;
            const response = err.response;  
            if(response.status == 400){
                if(typeof response.data.message === 'string'){
                    this.$notify({
                        type: 'warn',
                        text: response.data.message
                    });
                }
                else{
                    if(response.data.message['file']){
                        let fileList = response.data.message['file'];
                        for(let i=0;i<fileList.length;i++){
                            if(fileList[i].type==2 || fileList[i].type==5){
                                self.error.beneficiaryIdFront=fileList[i].message;
                            }
                            else if(fileList[i].type==3){
                                self.error.beneficiaryIdReverse=fileList[i].message;
                            }
                        }
                    }
                    self.success = false;
                    self.$emit('file-uploaded');
                }
            }      
            else if(response.status == 401 && response.data.name == "Unauthorized"){
                    localStorage.removeItem("token");
                    localStorage.removeItem("member");
                    localStorage.removeItem("isFirstTime");
                    this.$router.push({ 
                        path: '/login', 
                    });
            }
            else{
                if(localStorage.getItem("token")){
                    var msg = (response.data)?response.data.message:err.message;
                    this.$notify({
                        type: 'warn',
                        text: msg
                    })
                }
            }
        }catch(e){
            console.log(err);
        }
    },
    selectedDocumentBeneficiary(data){
        this.params.beneficiaryIdType = data.index+1;
        this.error.beneficiaryIdType = "";
    },
    togglePopup(index){
        this['showPopup_'+index]=!this['showPopup_'+index];
    },
    captureFile($event,key) {
        this.error[key]="";
        this.file[key]="";
        this.params[key]=$event;
    },
    removeImage($event,key){
        this.file[key]="";
        this.params[key]="";
    },
    doEscapeMarkup(markup){
        return markup;
    }
  }
}
</script>